export default {"src":"/_next/static/media/arrows_down_color.0d77a81a.svg","height":1070,"width":899,"blurWidth":0,"blurHeight":0};